"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("core-js/modules/es6.function.name");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const ArticleBody_1 = require("@components/atoms/ArticleBody");
const ArticleBody_2 = require("@components/atoms/ArticleBody");
const _theme_1 = require("@theme");
const _utils_1 = require("@utils");
var collage = require('../../assets/images/authors/wreaths/globe.png'); // Component
var AuthorBio = function AuthorBio(_ref) {
    var name = _ref.name, bio = _ref.bio, externalLink = _ref.externalLink;
    if (!name)
        return null;
    return /*#__PURE__*/ react_1.default.createElement(Wrapper, null, /*#__PURE__*/ react_1.default.createElement(AnchorLink, {
        id: "AuthorBio"
    }), /*#__PURE__*/ react_1.default.createElement(Content, null, /*#__PURE__*/ react_1.default.createElement(ImageWrapper, null, /*#__PURE__*/ react_1.default.createElement(AuthorImage, {
        src: collage
    })), /*#__PURE__*/ react_1.default.createElement(Copy, null, /*#__PURE__*/ react_1.default.createElement(Author, null, externalLink && /*#__PURE__*/ react_1.default.createElement("a", {
        href: externalLink,
        target: "_blank",
        rel: "noopener"
    }, name), !externalLink && /*#__PURE__*/ react_1.default.createElement("span", null, name)), bio && /*#__PURE__*/ react_1.default.createElement(Bio, {
        dangerouslySetInnerHTML: {
            __html: bio
        }
    }))));
}; // Styling
var Wrapper = styled_components_1.default.div.withConfig({
    displayName: "AuthorBio__Wrapper",
    componentId: "yc4gc-0"
})(["position:relative;", " ", ""], ArticleBody_1.articleWidth, ArticleBody_1.articlePadding);
var AnchorLink = styled_components_1.default.div.withConfig({
    displayName: "AuthorBio__AnchorLink",
    componentId: "yc4gc-1"
})(["position:absolute;top:-75px;width:1px;height:1px;"]);
var Content = styled_components_1.default.div.withConfig({
    displayName: "AuthorBio__Content",
    componentId: "yc4gc-2"
})(["padding:16px 0;border-top:1px solid rgba(37,35,33,0.64);", "{display:flex;flex-direction:row;justify-content:space-between;align-items:center;padding:20px 0;}", "{padding:24px 0;}", "{padding:32px 0;}"], _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop')); // Image
var ImageWrapper = styled_components_1.default.div.withConfig({
    displayName: "AuthorBio__ImageWrapper",
    componentId: "yc4gc-3"
})(["flex:0 0 auto;position:relative;width:160px;height:160px;border-radius:50%;margin:0 auto 16px;overflow:hidden;", "{margin:0;}", "{width:180px;height:180px;}", "{width:200px;height:200px;}"], _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
var AuthorImage = styled_components_1.default.img.withConfig({
    displayName: "AuthorBio__AuthorImage",
    componentId: "yc4gc-4"
})(["display:block;width:100%;height:100%;object-fit:cover;"]); // Copy
var Copy = styled_components_1.default.div.withConfig({
    displayName: "AuthorBio__Copy",
    componentId: "yc4gc-5"
})(["flex:1 1 auto;display:flex;flex-direction:column;justify-content:center;height:fit-content;text-align:center;", "{justify-content:flex-start;text-align:left;padding-left:24px;}", "{padding-left:32px;}"], _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('desktop'));
var Author = styled_components_1.default.div.withConfig({
    displayName: "AuthorBio__Author",
    componentId: "yc4gc-6"
})(["width:100%;", " ", ""], _theme_1.type.h3, ArticleBody_2.BodyCopyLink);
var Bio = styled_components_1.default.div.withConfig({
    displayName: "AuthorBio__Bio",
    componentId: "yc4gc-7"
})(["width:100%;padding-top:10px;", " ", "{padding-top:16px;}", ""], _theme_1.type.pSmall, _utils_1.mediaQuery('desktop'), ArticleBody_2.BodyCopyLink);
/*
const StyledLink = styled.a`
  display: inline;
  background-image: ${gradient.textUnderline};
  background-repeat: no-repeat;
  background-size: 100% 1px;
  background-position: -1000px calc(100% - 2px);
  width: 100%;
  margin-top: 17px;
  color: ${palette.ink};
  text-shadow:
    0 1px 0 ${palette.ivory},
    0 2px 0 ${palette.ivory},
    -1px 1px 0 ${palette.ivory},
    -1px 2px 0 ${palette.ivory},
    1px 1px 0 ${palette.ivory},
    1px 2px 0 ${palette.ivory},
    -1px 0 0 ${palette.ivory};
  transition: background-position 0.8s ease-in-out;
  will-change: background-position;
  ${type.label}

  ${mediaQuery('tablet')} {
    width: fit-content;
    &:hover {
      background-position: 0 calc(100% - 2px);
    }
  }

  ${mediaQuery('desktop')} {
    margin-top: 25px;
  }
`
*/
// Typing
exports.default = AuthorBio;
